import React from 'react';
import { connect } from 'react-redux';
import { Message, Container } from 'semantic-ui-react';

let MessageBox = ({messages}) => (
  <div style={{
    position: 'fixed',
    zIndex: 1,
    width: '100%',
    pointerEvents: 'none',
    bottom: '50px'
  }}>
    <Container style={{pointerEvents: 'auto'}}>
    {messages.map(({id, props, text, header, Custom}) =>
      Custom ? <Custom {...props} key={id}/> :
        <Message attached {...props} key={id}>
          {header && <Message.Header>
            {header}
          </Message.Header>}
          {text && <p>
            {text}
          </p>}
        </Message>
    )}
    </Container>
  </div>
)

const mapStateToProps = (state, props) => ({
  messages: state.message
})

MessageBox = connect(mapStateToProps)(MessageBox);

export default MessageBox;



// WEBPACK FOOTER //
// ./src/component/MessageBox.js